export enum CalendarFormatWeek {
    eventThumbnails = "Event Thumbnails",
    eventDescription = "Event Description",
    location = "Location"
}